import { type SVGProps, useId } from "react"

interface LandingLogoLiveTheGameHorizontalProps extends SVGProps<SVGSVGElement> {}

export function LandingLogoLiveTheGameHorizontal({ ...props }: LandingLogoLiveTheGameHorizontalProps) {
  const clipId = useId()

  return (
    <svg
      width="976"
      height="106"
      viewBox="0 0 976 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="LIVE THE GAME horizontal wordmark"
      {...props}
    >
      <title>LIVE THE GAME horizontal wordmark</title>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M24.83 83.3419H20.4L24.83 73.5619V1.67188H0V104.452H62.69L70.36 83.3419H26.29H24.83Z"
          fill="currentColor"
        />
        <path d="M97.9301 1.67188H73.1001V104.452H97.9301V1.67188Z" fill="currentColor" />
        <path
          d="M173.31 1.67188L159.45 46.8519C156.28 57.8219 153.1 69.3419 149.79 81.5519C146.34 69.3419 143.03 57.8219 139.65 46.8519L125.23 1.67188H98.1201L133.44 104.452H165.72L200.14 1.67188H173.31Z"
          fill="currentColor"
        />
        <path
          d="M288.16 22.7719H318.44V104.452H343.27V28.1019L338.73 22.7719H343.27H372.51V1.67188H293L288.16 22.7719Z"
          fill="currentColor"
        />
        <path
          d="M440.17 41.6119H402.04V1.67188H377.21V104.452H402.04V62.7119H440.17V104.452H465.01V1.67188H440.17V41.6119Z"
          fill="currentColor"
        />
        <path
          d="M272.95 22.6213L278.42 1.53125H210.27L200.52 29.4912V104.211H272.74L278.42 83.1213H221.69L227.3 62.8613H268.68L274.5 42.4013H221.69L227.3 22.6213H272.95Z"
          fill="currentColor"
        />
        <path
          d="M547.24 22.6213L552.72 1.53125H474.81V104.211H547.04L552.72 83.1213H495.98L501.6 62.8613H542.97L548.79 42.4013H495.98L501.6 22.6213H547.24Z"
          fill="currentColor"
        />
        <path
          d="M672.98 46.83H621.79L616.91 65.88H644.89C644.55 77.2 636.12 84.29 623.1 84.29C606.92 84.29 597.69 72.72 597.69 53.02C597.69 33.32 606.85 21.62 622.83 21.62C633.92 21.62 640.94 27.4 642.8 36.5H668.01C665.74 14.67 646.11 0 621.94 0C594.05 0 572.77 19.49 572.77 53.03C572.77 86.57 592.53 105.92 622.35 105.92C637.61 105.92 650.24 100.49 658.45 91.22L668.77 61.44L672.99 46.83H672.98Z"
          fill="currentColor"
        />
        <path d="M961.76 2.80844H964.1V9.16844H965.44V2.80844H967.77V1.64844H961.76V2.80844Z" fill="currentColor" />
        <path
          d="M974.08 1.64844L972.64 5.59844C972.5 6.01844 972.26 6.76844 972.08 7.35844C971.9 6.76844 971.66 6.01844 971.52 5.59844L970.06 1.64844H968.14V9.16844H969.45V5.32844C969.45 4.82844 969.42 4.03844 969.41 3.29844C969.67 4.10844 969.92 4.88844 970.08 5.32844L971.52 9.16844H972.61L974.04 5.32844C974.2 4.86844 974.46 4.03844 974.73 3.18844C974.71 3.95844 974.68 4.79844 974.68 5.32844V9.16844H975.99V1.64844H974.06H974.08Z"
          fill="currentColor"
        />
        <path
          d="M826.74 41.9384C824.81 48.4784 821.71 59.7784 819.16 69.4884C816.61 59.7784 813.44 48.4784 811.45 41.9384L798.23 1.64844H761.59V99.6884L727.71 1.64844H684.22L678.59 22.7184H687.82L659.8 104.258H686.73L693.05 84.4884H729.43L735.49 104.258H785.9V59.8384C785.9 53.0884 785.42 40.7584 785.14 28.9884C788.51 40.9684 791.96 53.2284 794.09 59.8384L809.1 104.258H829.14L843.88 59.8384C846.08 52.9484 849.6 40.0684 853.04 27.6084C852.76 39.7984 852.21 52.8184 852.21 59.8384V104.258H876.52V1.64844H839.81L826.72 41.9384H826.74ZM723.29 65.1484H699.07C703.54 50.4384 709.81 29.7984 711.46 23.8984C713.93 32.9584 719.31 51.2984 723.39 65.1484H723.3H723.29Z"
          fill="currentColor"
        />
        <path
          d="M955.49 22.7284L961.12 1.64844H883.08V104.268H955.44L961.12 83.1884H903.5L909.11 62.9484H947.72L953.53 42.4884H903.5L909.11 22.7184H909.22V22.7284H955.49Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="976.01" height="105.92" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
